<template>
  <tbody>
    <tr
      v-for="contractor in currentContractors"
      :key="contractor.id"
      class="table-row"
    >
      <td>{{ contractor.userAccount }}</td>
      <td>{{ displayI18nFullName(contractor.firstName, contractor.lastName) }}</td>
      <td>{{ contractor.contractorType }}</td>
      <td>{{ contractor.companyName }}</td>
      <td>{{ contractor.officeTel }}</td>
      <td>{{ contractor.mobile }}</td>
      <td class="last-login">
        {{ formatDate(contractor.user ? contractor.user.lastLoginAt : '') }}
      </td>
      <td class="last-invite">
        {{ formatDate(contractor.lastInviteDateTime) }}
      </td>
      <td>
        <HKLButton
          v-if="contractor.userAccount && canInvite"
          class="invite-btn no-min-width no-min-height"
          color="darkblue"
          action="invite"
          @click="invite(contractor)"
        />
      </td>
    </tr>
  </tbody>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { activateSawpContractorAndSendEmail } from '@/pages/ccd/tenancy.utils'
import formFullnameMixin from '@/pages/formFullnameMixin'
import dateUtil, { DD_MMM_YY_HH_MM as dateFormat } from '@/utils/dateUtil'
import HKLButton from '@/controls/Button/HKLButton.vue'
export default {
  components: {
    HKLButton,
  },
  mixins: [formFullnameMixin],
  props: {
    canInvite: Boolean,
  },
  data () {
    return {
      tenancyId: '',
    }
  },
  computed: {
    ...mapGetters('ccd', ['currentTenancy']),
    currentContractors () {
      return this.currentTenancy.tenancyContractors || []
    },
  },
  mounted () {
    this.tenancyId = this.$router.currentRoute.params.id
  },
  methods: {
    ...mapActions('ccd', ['loadTenancy']),
    formatDate (time) {
      return time ? dateUtil.format(time, dateFormat) : '-'
    },
    async invite (contractor) {
      await activateSawpContractorAndSendEmail(this.tenancyId, contractor)
      await this.loadTenancy(this.tenancyId)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-row {
  color: #0C3A58;
}
.invite-btn {
  height: 26px;
  padding: 0 10px;
}
.last-login {
  text-align: center;
}
.last-invite {
  text-align: center;
}
</style>
